<template>
  <div class="edit-video-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :before-close="handleClose"
               :close-on-click-modal="false" top="20px">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="类型:" prop="type">
          <el-select v-model="params.type" size="small">
            <el-option v-for="item in typeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跑马灯位置:" prop="position">
          <el-select v-model.number="params.position" size="small">
            <el-option v-for="item in positionOptions" :value="item.value" :label="item.label"
                       :key="item.value"></el-option>
          </el-select>
          <div class="fz11 red" v-if="params.position == 0">通用跑马灯：添加一次展示所有位置。针对不想每个位置添加一次的情况。如果添加了通用跑马灯会和各自模块的跑马灯融合一起展示。</div>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="params.title" placeholder="请输入标题" size="small"></el-input>
        </el-form-item>
        <el-form-item label="封面:" prop="cover" v-if="false">
          <base-upload :cover="params.cover" :action="action" @successCallback="handleAvatarSuccess" :wSize="90"
                       :hSize="90" :width="'90px'" :height="'90px'"></base-upload>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="params.content" size="small"></el-input>
        </el-form-item>
        <el-form-item label="链接类型:" prop="href">
          <el-select v-model="params.href" size="small">
            <el-option v-for="item in linkOptions" :value="item.value" :label="item.label"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" prop="href">
          <el-input v-model="params.href" size="small" placeholder="请填写链接"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sorted">
          <el-input v-model.number="params.sorted" size="small" placeholder="请填写排序"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-switch v-model="params.active">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      linkOptions: [
        {label: '外部链接', value: ''},
        {label: '会员中心(站内)', value: 'yinseinner://vip_page'},
        {label: '短视频(站内)', value: 'yinseinner://short_video'},
        {label: '套图(站内)', value: 'yinseinner://video_image'},
        {label: '积分福利(站内)', value: 'yinseinner://jf_fuli'},
        {label: '应用中心(站内)', value: 'yinseinner://yy_center'},
        {label: '金币充值(站内)', value: 'yinseinner://vip_coin'},
        {label: '账号凭据(站内)', value: 'yinseinner://account_code'},
        {label: '分享推广(站内)', value: 'yinseinner://share_tg'},
        {label: '帖子详情页(站内)', value: 'yinseinner://postdetail/(帖子ID: 括号内容请自行更换)'},
      ],
      positionOptions: [
        {label: '通用（所有位置都展示）', value: 0},
        {label: '首页', value: 1},
        {label: '暗网', value: 2},
        {label: '社区', value: 3},
        {label: '抖阴', value: 4},
        //{label: '图集', value: 6},
        //{label: '我的', value: 7},
        //{label: '播放详情', value: 8},
      ],
      typeList: [
        //{label: '首页公告', value: 1},
        // {label: '浮窗广告', value: 2},
        {label: '跑马灯', value: 3},
        //{label: '评论公告', value: 4},
      ],
      // 图片上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      params: {
        title: "",
        cover: "",
        content: '',
        href: '',
        type: 3,
        timeDays: 1,
        sorted: 1,
        position: 1,
        active: false
      },
      rules: {
        type: [{required: true, message: '请选择跑马灯类型', trigger: 'blur'}],
        title: [{required: true, message: '请输入标题', trigger: 'blur'}],
        content: [{required: true, message: '请输入内容', trigger: 'blur'}]
      }
    }
  },
  methods: {
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.cover = res.data.coverImg
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        title: "",
        cover: "",
        content: '',
        href: '',
        type: 3,
        timeDays: 1,
        sorted: 1,
        position: 1,
        active: false
      }
      this.$refs.form.resetFields()
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑跑马灯') {
            this.editAnnou()
          } else {
            this.addAnnou()
          }
        } else {
          return false;
        }
      });
    },
    editAnnou() {
      let params = Object.assign(this.params, {id: this.id});
      API.editAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    addAnnou() {
      let params = this.params;
      API.addAnnou(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerAnnouList')
        } else {
          this.$message.error('新增失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑跑马灯'
        this.params.title = data.title
        this.params.cover = data.cover
        this.params.content = data.content
        this.params.href = data.href
        this.params.active = data.active
        this.params.type = data.type

        this.params.timeDays = data.timeDays
        this.params.sorted = data.sorted
        this.params.position = data.position
        this.id = data.id
      } else {
        this.title = '新增跑马灯'
      }
    }
  }
}
</script>

<style lang="scss">
</style>
